import OpenInNewTabIcon from '@cp/src/assets/icons/OpenInNewTabIcon';
import MapLocationIcon from '@cp/src/assets/images/icons/MapLocationIcon';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import dayjs from 'dayjs';
import { DateFormat } from '@cp/src/utils/DateHelper';
import { IFeedback } from '../interfaces';
import { sanitizeString } from './utils';
import { openGoogleMapsWithCoordinates } from '@cp/src/utils/commonUtils';

const FeedbackItemHeader = (props: { feedbackDetails: IFeedback }) => {
  const { feedbackDetails } = props;
  const openFeedbackLocation = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e?.stopPropagation();
    openGoogleMapsWithCoordinates(
      feedbackDetails?.metadata?.interactionLatitude,
      feedbackDetails?.metadata?.interactionLongitude
    );
  };
  return (
    <div>
      <div className="flex items-center gap-1">
        <MapLocationIcon fillColor="var(--light-grayscale-content-2)" height={16} width={16} />
        <Typography variant="h4" color="var(--grayscale-content-1)">
          {sanitizeString(feedbackDetails?.interactionStatus)}
        </Typography>
      </div>
      <div className="ml-5 mb-4">
        <Typography variant="h6" color="var(--grayscale-content-3)">
          {sanitizeString(
            dayjs(feedbackDetails?.createdAt).format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME)
          )}{' '}
          | {sanitizeString(dayjs(feedbackDetails?.createdAt).format(DateFormat.HH_mm_A))}
        </Typography>
      </div>
      <Button
        variant="text"
        className="ml-5 mb-3"
        onClick={openFeedbackLocation}
        endAdornment={<OpenInNewTabIcon height={16} width={16} />}
      >
        Feedback Location
      </Button>
    </div>
  );
};

export default FeedbackItemHeader;
